import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SharedService } from 'src/app/providers/shared.service';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  taxSlabData:any = []
  selectedSlab:any = 'default'
  home_status: any = sessionStorage.getItem('home_service_status')
  shop_status: any = sessionStorage.getItem('shop_service_status')
  virtual_status: any = sessionStorage.getItem('virtual_service_status')
  isDiscountApplicable: boolean = false
  isTaxApplicable: boolean = false
  public productListData: any = {};
  isDiscount!: boolean;
  isShop: boolean = false
  isHome: boolean = false
  isVirtual: boolean = false
  isPercent!: boolean
  isAmount!: boolean
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  isVirtualSpecific: Boolean = false;
  entityHash: string = '';
  hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService,
    private sharedService: SharedService,
    public dialog: MatDialogRef<AddServiceComponent>
  ) {}
  removeAsset() {
    this.productListData.image_url = '';
    this.productListData.thumb_image_url = '';
    this.assetList = [];
  }
  priceCheker(){
    
    
    if(this.isHomeSpecific && (this.productListData.home_price == null || this.productListData.home_price < 0)){
      return true
    }
    else if(this.isShopSpecific && (this.productListData.shop_price == null || this.productListData.shop_price < 0)){
      return true
    }
    else if(this.isVirtualSpecific && (this.productListData.virtual_price == null || this.productListData.virtual_price < 0)){
      return true
    }
    else if(!this.isHomeSpecific && !this.isShopSpecific && !this.isVirtualSpecific){
      return true
    }
    else{
      return false
    }
  }
  discountChecker(){
    console.log();
    
    if(this.isDiscountApplicable){
      
      if(!this.productListData.discount_type || !this.productListData.discount){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }
  ngOnInit(): void {
    console.log(this.isDiscount);
    console.log(this.isPercent);
    this.productListData.discount_status = 0
    
    console.log(this.parentData.data);
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHash = data.entityHash

      
    })
    if(this.parentData.data){
      this.editMode = true;
      
     
      let data = JSON.parse(JSON.stringify(this.parentData.data))
      console.log(data);
      if (data.hash_id) {
        if(data.image_url && data.image_url != 'null'){
          this.assetList.push({
            assetName: data?.image_url
              .split('/')
              .pop()
              .substring(data.image_url.split('/').pop().lastIndexOf('_') + 1),
            url: data?.image_url,
            thumbnail: data?.thumb_image_url,
          });
        }
        this.productListData = data;
        // this.productListData.virtual_price = this.parentData.data.virtual_rate
        if(this.productListData.home_price == '-'){
          this.productListData.home_price = null
        }
        if(this.productListData.shop_price == '-'){
          this.productListData.shop_price = null
        }
        if(this.productListData.virtual_price == '-'){
          this.productListData.virtual_price = null
          this.productListData.virtual_rate = null
        }
      }
      if(data.shop_status == 1){
        this.isShop = true
        let eve = {
          checked: true,
          source: {
            value: 'shop'
          }
        }
        this.change(eve);
      }
      if(data.home_status == 1){
        this.isHome = true
        let eve = {
          checked: true,
          source: {
            value: 'home'
          }
        }
        this.change(eve);
      }
      if(data.virtual_status == 1){
        this.isVirtual = true
        let eve = {
          checked: true,
          source: {
            value: 'virtual'
          }
        }
        this.change(eve);
      }
      if(data.discount_status ==1){
        this.isDiscount = true
        this.isDiscountApplicable = true
      }
      if(data.discount_status == 0 || data.discount_status == null ){
        this.productListData.discount = null
        this.isDiscount = false
        this.isDiscountApplicable = false
  
      } 
      if(data.tax_collection_status ==1){
        if(this.isEntityForeign == '0'){
          this._apiService.getEntityTaxSlabData(this.entityHash)
        }
        else if(this.isEntityForeign == '1'){
          this._apiService.getInternationalEntityTaxSlabsData(this.entityHash)
        }
      }
      if(data.tax_collection_status == 0 || data.tax_collection_status == null){
        this.isTaxApplicable = false
        this.productListData.tax_slab_hash = null
        this.loaderservice.showLoader = false
      } 
      if(data.discount_type == 2 ){
        this.isAmount = true
      }
      if(data.discount_type == 1 ){
        this.isPercent = true
      }
      this.productListData.hsn_code = data.product_hsn_code
    }
    
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList.push({
          assetName: this.fileName,
          url: res.result?.url,
          thumbnail: res.result?.thumbnail,
        });
        this.productListData.image_url = res.result?.url;
        this.productListData.thumb_image_url = res.result?.thumbnail;
        this.loader = false;
      }
      
      if(res.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_PRODUCT){
        if(res.result){
          this.dialog.close({msg:'success'})
        }
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(res.result){
          if(!this.editMode){
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.loaderservice.showLoader = false

          }
          else{
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            let selectedTaxSlab = this.taxSlabData.filter((item:any) => item.hash_id == this.productListData.tax_slab_hash)
            
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.selectedSlab = selectedTaxSlab[0] ? selectedTaxSlab[0].hash_id : 'default'
            console.log(this.selectedSlab)
            this.loaderservice.showLoader = false
          }
        }
        else{
          this.isTaxApplicable = true
          this.loaderservice.showLoader = false
        }

      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(res.result){
         if(!this.editMode){
          this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.loaderservice.showLoader = false

          }
          else{
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            let selectedTaxSlab = this.taxSlabData.filter((item:any) => item.hash_id == this.productListData.tax_slab_hash)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.selectedSlab = selectedTaxSlab[0] ? selectedTaxSlab[0].hash_id : 'default'
            console.log(this.selectedSlab)
            this.loaderservice.showLoader = false
          }
        }
        else{
          this.isTaxApplicable = true
          this.loaderservice.showLoader = false
        }
      }
    });
  }
  change(event:any){
    console.log(event);
    if(event.checked == true && event.source.value == 'home'){
      this.isHomeSpecific = true
      this.productListData.home_status = 1
    } if(event.checked == true && event.source.value == 'shop'){
      this.isShopSpecific = true
      this.productListData.shop_status = 1
    } 
    if(event.checked == true && event.source.value == 'virtual'){
      this.isVirtualSpecific = true
      this.productListData.for_virtual = 1
      this.productListData.virtual_status = 1
    } 
    
    if(event.checked == false && event.source.value == 'home'){
      this.isHomeSpecific = false
      this.productListData.home_status = 0
      this.productListData.home_price = null
      this.productListData.home_discounted_price = null
    }if(event.checked == false && event.source.value == 'shop'){
      this.isShopSpecific = false
      this.productListData.shop_status = 0
      this.productListData.shop_price = null
      this.productListData.shop_discounted_price = null
    }
    if(event.checked == false && event.source.value == 'virtual'){
      this.isVirtualSpecific = false
      this.productListData.for_virtual = 0
      this.productListData.virtual_status = 0
      this.productListData.virtual_price = null
      this.productListData.virtual_price = null
      this.productListData.virtual_discounted_price = 0
      this.productListData.virtual_discounted_price = null
      
    }
    
  }

  onApp(event:any){

    if(event.target.value == 'applicable' ){
      this.productListData.discount_status = 1
    }if(event.target.value == 'not-applicable'){
      this.productListData.discount_status = 0
      this.productListData.discount = null
      this.productListData.discount_type = null
      this.isPercent = false
      this.isAmount = false
      this.productListData.home_discounted_price = null
      this.productListData.shop_discounted_price = null
      this.productListData.virtual_discounted_price = 0
      this.productListData.virtual_discounted_price = null
    }

  }

  discType(event:any){
    if(event.target.value == 'percent' ){
      this.productListData.discount_type = 1
    }if(event.target.value == 'amount'){
      this.productListData.discount_type = 2
    }

  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    // console.log('Data', this.productListData);
 
    console.log(this.editMode);
    if (!this.editMode) {
      // this.productListData['hash_id'] = undefined;
    }

    if(this.productListData.discount_type == 1){
      if(this.productListData.home_status != 0){
        this.productListData.home_discounted_price = this.productListData.home_price - (this.productListData.discount/100)*this.productListData.home_price
      }
      if(this.productListData.shop_status != 0){
        this.productListData.shop_discounted_price = this.productListData.shop_price - (this.productListData.discount/100)*this.productListData.shop_price
      }
      if(this.productListData.virtual_status != 0 && this.productListData.for_virtual != 0){
        this.productListData.virtual_discounted_price = this.productListData.virtual_price - (this.productListData.discount/100)*this.productListData.virtual_price
      }
      
    }else if(this.productListData.discount_type == 2){
      if(this.productListData.home_status != 0){
        this.productListData.home_discounted_price = this.productListData.home_price - this.productListData.discount
      }
      if(this.productListData.shop_status != 0){
        this.productListData.shop_discounted_price = this.productListData.shop_price - this.productListData.discount
      }
      if(this.productListData.virtual_status != 0){
        this.productListData.virtual_discounted_price = this.productListData.virtual_price - this.productListData.discount
      }
      
     
    }

    if(this.productListData.home_status == 0){
      this.productListData.home_price = 0
    }
    
    if(this.productListData.shop_status == 0){
      this.productListData.shop_price = 0
    }
    if(this.productListData.virtual_status == 0){
      this.productListData.virtual_price = 0
    }
    if(this.productListData.discount_status == 0  || this.productListData.discount_status == null){
      this.productListData.discount_status == 0
      this.productListData.discount = 0
      this.productListData.home_discounted_price = 0
      this.productListData.shop_discounted_price = 0
      this.productListData.virtual_discounted_price = 0
    }
    if(this.productListData.tax_collection_status == 0  || this.productListData.tax_collection_status == null){
      this.productListData.tax_collection_status == 0
      this.productListData.tax_slab_hash = null
    }

    if(this.productListData.home_price == '-'){
      this.productListData.home_price = 0
    }
    if(this.productListData.shop_price == '-'){
      this.productListData.shop_price = 0
    }
    if(this.productListData.virtual_rate == '-'){
      this.productListData.virtual_price = 0
    }
    if(this.productListData.home_discounted_price == '-'){
      this.productListData.home_discounted_price = 0
    }
    if(this.productListData.shop_discounted_price == '-'){
      this.productListData.shop_discounted_price = 0
    }
    if(this.productListData.virtual_discounted_price == '-'){
      this.productListData.virtual_discounted_price = 0
    }

    let obj = {
      "hash_id": this.productListData.hash_id ?? null,
      "entity_hash": this.entityHash,
      "product_name": this.productListData.product_name,
      "product_desc": this.productListData.product_desc,
      "manufacturer": this.productListData.manufacturer,
      "shop_price": this.productListData.shop_price ?? 0,
      "home_price": this.productListData.home_price ?? 0,
      "virtual_price": this.productListData.virtual_price ?? 0,
      "discount": this.productListData.discount ?? 0,
      "tax_slab_hash": this.selectedSlab == 'default' ? null : this.selectedSlab,
      "image_url": this.productListData.image_url,
      "thumb_image_url": this.productListData.thumb_image_url,
      "product_type_hash": null,
      "inventory_item_hash": this.productListData.inventory_item_hash ?? null, 
      "discount_status": this.productListData.discount_status, // send as 0 if null
      "discount_type": this.productListData.discount_type,
      "shop_discounted_price": Number.isNaN(this.productListData.shop_discounted_price) ? 0 :  this.productListData.shop_discounted_price ,
      "home_discounted_price": Number.isNaN(this.productListData.home_discounted_price) ? 0 :  this.productListData.home_discounted_price ,
      "virtual_discounted_price": Number.isNaN(this.productListData.virtual_discounted_price) ? 0 :  this.productListData.virtual_discounted_price ,
      "home_status": this.productListData.home_status ?? 0,
      "shop_status": this.productListData.shop_status ?? 0,
      "virtual_status": this.productListData.virtual_status ?? 0,
      "tax_collection_status": this.productListData.tax_collection_status ?? 0, // send as 0 if null
      "hsn_code": this.productListData.hsn_code,
      "qty_info": this.productListData.qty_info,
      "selling_unit": this.productListData.selling_unit,
      "purchase_unit": this.productListData.inventory_item_hash ? (this.productListData.purchase_unit && this.productListData.purchase_unit != 'null' ? this.productListData.purchase_unit : this.productListData.selling_unit) :this.productListData.selling_unit ,
      "selling_purchase_multiplier": this.productListData.selling_purchase_multiplier && this.productListData.selling_purchase_multiplier != 'null' ? this.productListData.selling_purchase_multiplier : 1,
    }


    Object.keys(obj).forEach(key => {
      if ((obj as any)[key] === null || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });
  
//  let bodydata = {
//   serviceTypeInfo: this.productListData
//  }
    console.log('updated data', obj);
    this.loaderservice.showLoader = true
    this._apiService.addEditEntityProduct(obj)
    
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  // locationAutoComplete(event: any) {
  //   console.log('location', event.place.address_components);
  //   // administrative_area_level_1 = state
  //   // locality = city
  //   // country = country
  //   event.place.address_components?.forEach((data: any) => {
  //     let type = data.types[0];
  //     console.log(type);
  //     if (type === 'administrative_area_level_1') {
  //       this.productListData.targetState = data?.long_name;
  //     } else if (type === 'locality') {
  //       this.productListData.targetCity = data.long_name;
  //     } else if (type === 'country') {
  //       this.productListData.targetCountry = data.long_name;
  //     }
  //   });
  // }

  onToggleChange(event: any){
    
    if(event.checked){
      this.isDiscountApplicable = true
      this.productListData.discount_status = 1
    }
    else if(!event.checked){
      this.isDiscountApplicable = false
      this.productListData.discount_status = 0
      this.productListData.discount = null
      this.productListData.discount_type = null
      this.isPercent = false
      this.isAmount = false
      this.productListData.home_discounted_price = null
      this.productListData.shop_discounted_price = null
    }
  }
  onToggleChangeForTax(event: any){
    this.selectedSlab = 'default'
    if(event.checked){
      this.loaderservice.showLoader = true
      if(this.isEntityForeign == '0'){
        this._apiService.getEntityTaxSlabData(this.entityHash)
      }
      else if(this.isEntityForeign == '1'){
        this._apiService.getInternationalEntityTaxSlabsData(this.entityHash)
      }
    
    }
    else if(!event.checked){
      this.isTaxApplicable = false
      this.productListData.tax_collection_status = 0
      this.productListData.tax_slab_hash = null
    }
  }

  configureTax(){
    this.dialog.close()
    this.router.navigate(['/businesses/details/tax-and-gst'],{queryParams: {entityHash: this.entityHash}})
  }

}
